import { render, staticRenderFns } from "./Certificados.vue?vue&type=template&id=92b13f7e"
import script from "./Certificados.vue?vue&type=script&lang=js"
export * from "./Certificados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92b13f7e')) {
      api.createRecord('92b13f7e', component.options)
    } else {
      api.reload('92b13f7e', component.options)
    }
    module.hot.accept("./Certificados.vue?vue&type=template&id=92b13f7e", function () {
      api.rerender('92b13f7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/certificados/oficial-registro/Certificados.vue"
export default component.exports